import axios from "axios";
import {ordersServicesPath} from "../../../../Constants";

const requestsCuttingServiceRestUrl = ordersServicesPath + '/customers/requests-cutting'
const requestsCuttingServiceRestUrlOrganizations = ordersServicesPath + '/organizations/requests-cutting'

export default class CustomerRequestsCuttingService {
    static async getAllByCustomerOrderId(orderId) {
        return axios.get(requestsCuttingServiceRestUrl + '/by-order-id?orderId=' + orderId, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    static async getAllByCustomerOrderIdForCloud(orderId) {
        return axios.get(requestsCuttingServiceRestUrlOrganizations + '/by-order-id-for-cloud?orderId=' + orderId, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    static async add(data) {
        return axios.post(requestsCuttingServiceRestUrl, data, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    static async edit(id, data) {
        return axios.put(requestsCuttingServiceRestUrl + "/" + id, data, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }
    static async editOrg(id, data) {
        return axios.put(requestsCuttingServiceRestUrlOrganizations + "/" + id, data, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }
    static async replaceMaterial(id, materialOrganizationOptionId) {
        return axios.put(requestsCuttingServiceRestUrlOrganizations + "/replace-material/" + id +"?materialOrganizationOptionId="+materialOrganizationOptionId, {}, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    static async delete(id) {
        return axios.delete(requestsCuttingServiceRestUrl + "/" + id, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

}